<template>
  <div class="randomized">
    <div class="column" v-for="(col, index) in kana" :key="index">
      <zoom-center-transition group>
        <div class="seion" v-if="kana[characterSet]" v-for="kana in col" :key="kana.romaji"
          v-bind:class="{ selected: kana[characterSet] && kana.selected }"
          @click="kanaClicked(kana)">{{kana[characterSet]}}</div>
      </zoom-center-transition>

      <div class="column" v-if="last === index">
        <div class="seion placeholder">?</div>
        <div class="seion placeholder">?</div>
        <div class="seion placeholder">?</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ZoomCenterTransition } from 'vue2-transitions';

export default {
  name: 'RandomizedKana',
  props: {
    characterSet: {
      default: 'hiragana',
      type: String
    },
    kana: {
      type: Array
    }
  },
  components: {
    ZoomCenterTransition
  },
  computed: {
    last() {
      return this.kana.length - 1;
    }
  },
  methods: {
    kanaClicked(kana) {
      if(!this.firstSelection) {
        this.firstSelection = true;
        this.$emit('first-kana-selection');
      }
      this.$emit('kana-selected', { kana, characterSet: this.characterSet });
    }
  }
};
</script>

<style lang="less" scoped>
@import (reference) '../styles/variables.less';

.randomized {
  border-top: 1px solid @bright-turquoise;
  display: flex;
  padding: 20px;
  margin-top: 22px;

  @media @smartphones, @tablets {
    padding-top: 10px;
  }

  @media @landscape-tables-phones {
    border-top: 0;
    border-left: 1px solid @bright-turquoise;
    margin: 0;
    padding: 0;
    margin-left: 25px;
    padding-left: 20px;
  }

  .seion {
    width: auto;
    min-width: 70px;
    min-height: 40px;
    margin: 5px;
    font-size: @seion-font-size - 20;
    border: 1px solid @seion-border;
    padding: 1px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.placeholder {
      color: transparent;
      background: lighten(@dark-gunmetal, 80%);
    }

    &.selected {
       background-color: @dark-gunmetal;
       color: @white;
    }

    @media (hover: hover) {
      &:hover {
        &:not(.placeholder) {
          background-color: @dark-gunmetal;
          color: @white;
        }
      }
    }

    @media @smartphones, @tablets {
      min-width: 28px;
      min-height: 22px;
      font-size: 22px;
      padding: 0;
    }

    @media @landscape-tables-phones {
        min-width: 24px;
        min-height: 24px;
        font-size: 20px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/RandomizedKana.vue